<template>
	<v-expand-transition>
		<slot />
	</v-expand-transition>
</template>

<script>
export default {
	name: 'KExpandTransition'
};
</script>